import { useTranslation } from 'react-i18next'

import { EskatDummyTextStyle } from '../Eskat.styled'

interface EskatDummyTextProps {
	showDummyText: boolean
}

export const EskatDummyText = ({ showDummyText }: EskatDummyTextProps) => {
	const { t } = useTranslation()
	if (showDummyText) {
		return (
			<EskatDummyTextStyle>
				{t('consent-dummyDataExplanation-txt')}
			</EskatDummyTextStyle>
		)
	}
	return null
}
